import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import Point from "slotworks/utils/geom/point";
import * as TweenJS from "slotworks/utils/tween";
import { sequence, parallel } from "slotworks/utils/race-utils";
import RevolverWinTransitions from "./revolver-win-transitions";
import { ZoomOut, FadeOut } from "slotworks/graphics/animation/base-animations";
import soundManager from "slotworks/sound/sound-manager";
import gameState from "slotworks/model/game-state";
import Components from "slotworks/components/components";
import { StartBaseMusic } from "commands/music";

export default class SuperMegaWinTransitions extends RevolverWinTransitions {
    public TEXT_ZOOM = 1;
    private super: PIXI.Sprite;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.inResolve = resolve;

            RevolverWinTransitions.glitter.emit = true;
            RevolverWinTransitions.coinsLeft.emit = true;
            RevolverWinTransitions.coinsRight.emit = true;
            this.super = Layers.CelebrationContent.getSprite("super");
            this.titleIn(this.super, new Point(0.5, 1)).then(() => {
                if (RevolverWinTransitions.currentTiers.length > 3)
                    this.hoverTitleBigWin(this.super, 2);
                else
                    this.endlessHover(this.super);
                this.resolveIn();
            });
        });
    }

    public skipIn() {
        this.destroy();

        this.endlessHover(this.super);
        soundManager.customEvent("supermega_win");
        RevolverWinTransitions.winValue.visible = true;
        this.setTextSize(this.TEXT_ZOOM);

        // RevolverWinTransitions.glitter.emit = true;
        // RevolverWinTransitions.coinsLeft.emit = true;
        // RevolverWinTransitions.coinsRight.emit = true;

        this.resolveIn();
    }

    public out(): Contract<void> {
        RevolverWinTransitions.removeOrientationChange();
        return parallel([
            () => this.zoomOutStacks(),
            () => sequence([
                () => Contract.wrap(() => {
                    TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                    const totalWin = gameState.getCurrentGame().totalCreditsWon;
                    Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);
                    RevolverWinTransitions.glitter.emit = false;
                    RevolverWinTransitions.coinsLeft.emit = false;
                    RevolverWinTransitions.coinsRight.emit = false;
                    soundManager.customEvent("plaque_transition");
                }),
                () => parallel([
                    () => ZoomOut(RevolverWinTransitions.winValue, 50),
                    () => this.titleOut(this.super, new Point(0.5, 1), 50)
                ]),
                () => Contract.wrap(() => {
                    TweenJS.removeAll(this.super.scale);
                    TweenJS.removeAll(this.super);
                    TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                    this.super.visible = false;
                    soundManager.customEvent("celebration_end");
                    // soundManager.customEvent("base_reels_background_start");
                    StartBaseMusic(true);
                }),
                () => FadeOut(RevolverWinTransitions.background, this.BOUNCE_TIME),
                () => Contract.getTimeoutContract(750)
            ])
        ]);
    }

    public destroy() {
        this.clearTimers();

        TweenJS.removeAll(this.super.scale);
        TweenJS.removeAll(this.super);

        super.destroy();
    }
}